import { Col, Icons, Row } from '@pankod/refine-antd'
import './style.less'
import React from 'react'
import { useGetIdentity, useList } from '@pankod/refine-core'
import { useSupportTasksCount } from 'utility'
// import DashBoardChart from 'components/chart/Chart'

const { QuestionOutlined, ExceptionOutlined, ProjectOutlined, LikeOutlined, UserOutlined, RightCircleOutlined } = Icons

const SupportDashboard: React.FC = () => {
  const { data } = useGetIdentity()
  const support_id = data?.id
  const { data: assignedTasks } = useSupportTasksCount(support_id, 'Assigned')
  const { data: pendingTasks } = useSupportTasksCount(support_id, 'In Progress')
  const { data: completedTasks } = useSupportTasksCount(support_id, 'Completed')
  return (
    <Row gutter={16} className="mt-3">
      <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
        <div className="dashboard-card1">
          <Row className="card-content">
            <Col md={18} className="text-container">
              <h4> Assigned Tasks </h4>
              <h3 style={{ margin: '0' }}>{assignedTasks?.total}</h3>
            </Col>
            <Col md={6} className="icon-container">
              <ProjectOutlined className="icon" />
            </Col>
          </Row>
        </div>
      </Col>
      <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
        <div className="dashboard-card1">
          <Row className="card-content">
            <Col md={18} className="text-container">
              <h4> Pending Tasks </h4>
              <h3 style={{ margin: '0' }}>{pendingTasks?.total}</h3>
            </Col>
            <Col md={6} className="icon-container">
              <ProjectOutlined className="icon" />
            </Col>
          </Row>
        </div>
      </Col>
      <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
        <div className="dashboard-card1">
          <Row className="card-content">
            <Col md={18} className="text-container">
              <h4> Completed Tasks </h4>
              <h3 style={{ margin: '0' }}>{completedTasks?.total}</h3>
            </Col>
            <Col md={6} className="icon-container">
              <ProjectOutlined className="icon" />
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
    // {breakpoint.md&&<div style={{marginTop:'4rem'}}>
    // <DashBoardChart details={details} label={label} />
    // </div>}
    // </>
  )
}

export default SupportDashboard
